import { render, staticRenderFns } from "./AnimatedStages.vue?vue&type=template&id=40f654c2&scoped=true&"
import script from "./AnimatedStages.vue?vue&type=script&lang=js&"
export * from "./AnimatedStages.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedStages.vue?vue&type=style&index=0&id=40f654c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f654c2",
  null
  
)

export default component.exports